import { BaseballIncidentId } from '@collector/sportsapi-client-legacy'

import { IncidentsResultConfig } from '../../configuration'

export const incidentsResultConfig: IncidentsResultConfig<BaseballIncidentId> =
  {
    scoringIncidents: new Map([
      [BaseballIncidentId.HomeRun, { add: 1, visible: true }],
      [BaseballIncidentId.Run, { add: 1, visible: true }],
    ]),
  }
